import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

// export * from 'gsap';
// export * from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(ScrollTrigger);

export { gsap };
